import Styled from 'styled-components'

export const Container = Styled.div`
  .swiper-pagination-bullet{
    display: none !important;
  }
`

export const Img = Styled.img`
  width: 115px;
  height: 105px;
  object-fit: cover;  
  border-radius: 6px;
`

export const Span = Styled.span`
  weight: 500;
  display: block;
  cursor: pointer;
  text-align: center;
  margin-top: 7px;
  font-size: 16px;
  line-height: 150%;
  word-wrap: break-word;
  color: ${props => props.theme.whitelabel?.text_primary_color};
  @media(max-width: 800px) {
    margin-top: 7px;
  }
`
